export const CONTACT_ASSIGNED = -1;

export const UPDATE_TASK_INTERVAL = 10000;

export const TAB_V1 = 'V1';
export const TAB_V21 = 'V21';
